import React, { useContext } from "react";
import { Grid } from "@material-ui/core";
import Cookies from "universal-cookie";

import { Button } from "../childrens/Button";

import { CardContext } from "../../../context/CardContext";
import { AuthContext } from "../../../../../../contexts/AuthContext";

import { css } from "./styles";

//controllers
import Qualidade_controller from "../../../../../../controllers/qualidade";

export function ButtonsGrid(props) {
    const styles = css();

    const { handleClick, upload_file } = props;
    const { pdf_link, status, tipo_card } = useContext(CardContext);
    const {
        user: { isVisaoTok },
    } = useContext(AuthContext);

    const button_labels = {
        ver: "VER FICHA TÉCNICA",
        enviar: "ENVIAR FICHA TÉCNICA",
        substituir: "SUBSTITUIR FICHA TÉCNICA",
    };

    const handleClickMovel = async () => {
        if (status === "Pendente") {
            upload_file();
        } else {
          try {
            const cookies = new Cookies();
            const token = cookies.get("User-Token");
            const query = {
                key: pdf_link,
            };
            const o_qualidade = await Qualidade_controller.getURLFile(token, query);
            if (o_qualidade.res.statusCode == 200) {
                window.open(o_qualidade.body, "_blank");
            }
          } catch(error) {
            console.error(error);
          }
        }
    };

    return (
        <Grid className={styles.buttons_grid}>
            {(isVisaoTok || status === "Aprovado") && (
                <Button
                    variant="contained"
                    label={status === "Pendente" ? button_labels.enviar : button_labels.ver}
                    handleClick={tipo_card === "a" ? handleClick : handleClickMovel}
                />
            )}

            {isVisaoTok && status === "Aprovado" && tipo_card === "m" && (
                <Button
                    variant="outlined"
                    label={button_labels.substituir}
                    handleClick={upload_file}
                />
            )}
        </Grid>
    );
}
